export const EShapeActionValueChangeTextType = wcardinal.ui.EShapeActionValueChangeTextType;